export default __webpack_public_path__ + "img/star-icon.svg";